import { useAuth } from '@/contexts/auth';

export interface PermissionSet {
  isAdmin: boolean;
  isAuthenticated: boolean;
  canModerate: boolean; // synonym for admin for now (future: roles)
}

export function usePermissions(): PermissionSet {
  const { user, isAdmin } = useAuth();
  return {
    isAdmin: !!isAdmin,
    isAuthenticated: !!user,
    canModerate: !!isAdmin,
  };
}
